import React, { useEffect, useState } from "react";
import HeaderSection from "../../components/header";
import HeroSection from "../../components/herosection";
import image from "../../assets/pngegg.png";

import PurposeOfSweep from "./PurposeOfSweep";
import CommonHeroSection from "../../components/CommonHeroSection/CommonHeroSection";
import WhereItStartedSection from "./WhereItStartedSection/WhereItStartedSection";
import InstalledSection from "./InstalledSection";
import image1 from "../../assets/about_us_bg.png";
import image2 from "../../assets/about2.png";

import Footer from "../../components/footerSection";
import TestimonialSection2 from "../../components/TestimonialSection2";
import OurGlorySection from "../../components/OurGlorySection";

function AboutUs() {

  let data = {
    title: "Where it all started",
    description: `Established in 2001, Leduc Chimney Sweeps Ltd. a.k.a The 
    Fireplace Store is located 
    in Alberta, Canada. Since 2 decades
    now we have been serving our prestigious customers with 
    Services like Chimney Sweeping, WETT Inspections, Supplies
    to maintain and Clean Firestoves and
     Fireplaces, Fireplace 
    and Chimney Installation. At Leduc chimney Sweeps., we also
    assist our customers with repair and maintenance for both 
    Chimney and Fireplace as well as Masonry work. `,
    image: image,
  };





  return (
    <div className="AboutUs">
      <HeaderSection />
      <CommonHeroSection 
      imgName={image1}
      titleHead="About Us"
      extraContent={`Home > About Us`}
      />
      <WhereItStartedSection />
      <PurposeOfSweep />
      <OurGlorySection />
      <InstalledSection />
      <TestimonialSection2 />
      <Footer/>
    </div>
  );
}

export default AboutUs;
